export const queryKeys = {
  bootstrap: () => ['bootstrap'],
  catalog: (type, rubric) => ['catalog', type, rubric || null],
  catalogRubricRow: (type, rubric) => [
    'catalog-rubric-row',
    type,
    rubric?.slug || null,
    rubric?.order ?? null,
  ],
  creditsPackages: () => ['credits-packages'],
  creditsPaymentStatus: (paymentId) => ['credits-payment-status', paymentId || null],
  gallery: (filter) => ['gallery', filter || 'all'],
  galleryItem: (id) => ['gallery-item', id || null],
  history: (params = {}) => ['history', params?.type || 'all', params?.period || 'all'],
  legacyUserHistory: (params = {}) => [
    'user-history',
    params?.type || 'ALL',
    params?.period || 'ALL',
  ],
  presetGroup: (groupId) => ['preset-group', groupId || null],
  presetGroups: () => ['preset-groups'],
  promptPresets: (presetId) => ['presets', presetId || 'all'],
  profile: () => ['profile'],
  referral: () => ['referral'],
  subscriptionCurrent: () => ['subscription-current'],
  subscriptionPaymentStatus: (paymentId) => ['subscription-payment-status', paymentId || null],
  subscriptionPlans: () => ['subscription-plans'],
};
